import _decorate from "@babel/runtime/helpers/esm/decorate";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { html, property } from 'lit-element';
import { nothing } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { addVisualViewportResizeListener, isMobile } from '../../utils/mobile-helpers';
import { KatLitElement } from './kat-lit-element';
export let KatLitMobileElement = _decorate(null, function (_initialize, _KatLitElement) {
  class KatLitMobileElement extends _KatLitElement {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: KatLitMobileElement,
    d: [{
      kind: "field",
      static: true,
      key: "noScrollCssClassname",
      value() {
        return 'mobile-no-scroll';
      }
    }, {
      kind: "field",
      key: "expandedPropertyName",
      value() {
        return 'expanded';
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'mobile-emulated-modal',
        type: Boolean
      })],
      key: "mobileEmulatedModal",
      value() {
        return true;
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'include-exportparts',
        type: Boolean
      })],
      key: "includeExportparts",
      value() {
        return false;
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "exportparts",
      value: void 0
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(KatLitMobileElement.prototype), "connectedCallback", this).call(this);
        addVisualViewportResizeListener();
      }
    }, {
      kind: "method",
      key: "firstUpdated",
      value: function firstUpdated() {
        _get(_getPrototypeOf(KatLitMobileElement.prototype), "firstUpdated", this).call(this);
        if (!this.includeExportparts) {
          return;
        }
        this.exportparts = ['mobile-emulated-modal-mask', 'mobile-emulated-modal-wrapper', 'mobile-emulated-modal-header', 'mobile-emulated-modal-close', 'mobile-emulated-modal-container', 'mobile-emulated-modal-content', 'mobile-emulated-modal-footer', 'mobile-emulated-modal-item', 'mobile-emulated-modal-search'].join(',');
      }
    }, {
      kind: "method",
      key: "updated",
      value: function updated(changedProperties) {
        _get(_getPrototypeOf(KatLitMobileElement.prototype), "updated", this).call(this, changedProperties);
        if (!this.mobileEmulatedModal || !changedProperties.has(this.expandedPropertyName)) {
          return;
        }
        if (!this[this.expandedPropertyName] && changedProperties.get(this.expandedPropertyName) === undefined) {
          return;
        }
        const isExpanded = this[this.expandedPropertyName];
        document.body?.classList.toggle(KatLitMobileElement.noScrollCssClassname, isExpanded);
        if (isExpanded) {
          this.disableBodyScrolling();
        } else {
          this.enableBodyScrolling();
        }
      }
    }, {
      kind: "method",
      key: "getMobileHeader",
      value: function getMobileHeader(expanded, handleClick, ariaLabelClose, label) {
        if (!expanded) {
          return nothing;
        }
        return html`<div part="mobile-emulated-modal-header" style="display: none"> ${label || nothing}<button type="button" part="mobile-emulated-modal-close" @click="${handleClick}" aria-label="${ariaLabelClose}"> <kat-icon name="close" size="small"></kat-icon> </button> </div>`;
      }
    }, {
      kind: "method",
      key: "getPart",
      value: function getPart(name, expanded, legacyName) {
        const names = [];
        if (expanded) {
          names.push(name);
        }
        if (legacyName) {
          names.push(legacyName);
        }
        return ifDefined(names.join(' '));
      }
    }, {
      kind: "method",
      key: "getPartMask",
      value: function getPartMask(expanded, legacyName) {
        return this.getPart('mobile-emulated-modal-mask', expanded, legacyName);
      }
    }, {
      kind: "method",
      key: "getPartWrapper",
      value: function getPartWrapper(expanded, legacyName) {
        return this.getPart('mobile-emulated-modal-wrapper', expanded, legacyName);
      }
    }, {
      kind: "method",
      key: "getPartContainer",
      value: function getPartContainer(expanded, legacyName) {
        return this.getPart('mobile-emulated-modal-container', expanded, legacyName);
      }
    }, {
      kind: "method",
      key: "getPartContent",
      value: function getPartContent(expanded, legacyName) {
        return this.getPart('mobile-emulated-modal-content', expanded, legacyName);
      }
    }, {
      kind: "method",
      key: "getPartSearch",
      value: function getPartSearch(expanded, legacyName) {
        return this.getPart('mobile-emulated-modal-search', expanded, legacyName);
      }
    }, {
      kind: "method",
      key: "getPartItem",
      value: function getPartItem(expanded, legacyName) {
        return this.getPart('mobile-emulated-modal-item', expanded, legacyName);
      }
    }, {
      kind: "field",
      key: "scrollOffset",
      value: void 0
    }, {
      kind: "field",
      key: "scrollElement",
      value() {
        return document.scrollingElement || document.documentElement;
      }
    }, {
      kind: "method",
      key: "disableBodyScrolling",
      value: function disableBodyScrolling() {
        if (!isMobile()) {
          return;
        }
        this.scrollOffset = window.scrollY;
        this.scrollElement.style.overflow = 'hidden';
        this.scrollElement.style.top = -this.scrollOffset + 'px';
      }
    }, {
      kind: "method",
      key: "enableBodyScrolling",
      value: function enableBodyScrolling() {
        this.scrollElement.style.removeProperty('overflow');
        this.scrollElement.style.removeProperty('top');
        if (isMobile()) {
          setTimeout(() => window.scrollTo(0, this.scrollOffset), 0);
        }
      }
    }]
  };
}, KatLitElement);
//# sourceMappingURL=kat-lit-mobile-element.js.map